export function externalLink() {
  const externalLinkContainer = document.querySelectorAll('.external-link-container');
  if(externalLinkContainer.length) {
    externalLinkContainer.forEach(function(container) {
      const a = container.querySelectorAll('a');
      if(a.length) {
        a.forEach(function(_a) {
          if (location.host !== _a.host) {
            const href = _a.getAttribute("href");
            if (href && href !== "#" && href !== "javascript:void(0)") {
              _a.setAttribute("target", "_blank");
            }
          }
        })
      }
    });
  }
}